import { call, put, takeLeading } from 'redux-saga/effects';
import actions from './actions';
import errorActions from '../error/actions';
import dxApi from 'services/dxApi';

const {
  Types: { LOAD_MEMBERSHIP_AGREEMENT_PDF_REQUEST, LOAD_MEMBERSHIP_RECEIPT_PDF_REQUEST },
  Creators,
} = actions;

const {
  Creators: { setError },
} = errorActions;

function* loadMembershipAgreementPDF({ payload }) {
  try {
    const { data } = yield call(dxApi.post, `/api/ols/documents/base64`, payload);

    // Always extract both PDFs from the single response
    const receiptBase64 = data?.data?.receiptBase64;
    const receiptFileName = data?.data?.receiptFileName || 'receipt';
    const membershipBase64 = data?.data?.membershipAgreementBase64;
    const membershipFileName =
      data?.data?.memberShipAgreementFileName || 'membership-agreement';

    if (receiptBase64 && membershipBase64) {
      // Store both PDFs
      const bothPDFs = {
        receiptPDF: {
          base64Data: receiptBase64,
          fileName: receiptFileName,
          documentType: 'receipt',
        },
        membershipAgreementPDF: {
          base64Data: membershipBase64,
          fileName: membershipFileName,
          documentType: 'membership-agreement',
        },
      };

      yield put(Creators.loadMembershipAgreementPDFSuccess(bothPDFs));
    } else {
      yield put(setError('PDF data not found'));
    }
  } catch (error) {
    yield put(Creators.loadMembershipAgreementPDFFailure(error));
    yield put(setError('Loading PDF error.'));
  }
}

function* loadMembershipReceiptPDF({ payload }) {
  try {
    const { data } = yield call(
      dxApi.post,
      `/api/ols/upload-photo/olstncdocumnetreceipt`,
      payload,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }
    );

    if (!data.success) {
      yield put(Creators.loadMembershipReceiptPDFFailure(data.message));
    } else {
      yield put(Creators.loadMembershipReceiptPDFSuccess(data.data));
    }
  } catch (error) {
    yield put(Creators.loadMembershipReceiptPDFFailure(error));
  }
}

export function* downloadPdfSaga() {
  yield takeLeading(LOAD_MEMBERSHIP_AGREEMENT_PDF_REQUEST, loadMembershipAgreementPDF);
  yield takeLeading(LOAD_MEMBERSHIP_RECEIPT_PDF_REQUEST, loadMembershipReceiptPDF);
}
